import { PersonInfo, Subscriber } from 'types/electionService';
import { getElectionFormById } from 'api/operations/formService';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { RootStore, getRootStoreInstance } from 'store/rootStore';
import { updateSubscriberInfo } from 'api/operations/electionService';
import ModalDelegate from 'store/general/modalDelegate';
import { DynamicFormDelegate } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { FormObjectFromJSON } from '@insurancemenu/imenu-components-lib/dist/types/dynamicForms';
import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types/Toast';

interface DomainParams {
  periodId: string;
}

export default class ProductLineRateModalDelegate extends ModalDelegate {
  private _periodId: string;
  private _rootStore: RootStore = getRootStoreInstance();
  private _subscriber: Subscriber | null = null;
  private _productId = '';

  public dynamicFormDelegate = new DynamicFormDelegate({
    currentUserRoles: this._rootStore.userStore.userRoles,
    fetchForm: async (formId: string): Promise<FormObjectFromJSON> => {
      const carrierId = this._rootStore.domainStoreV2.domainHeader.id;
      return getElectionFormById(formId, carrierId, this._subscriber?.employeeClass || '', this._productId);
    },
    onSubmit: this.updateSubscriberWithPLineFormAnswers.bind(this),
  });

  async openAndFetchForm(subscriber: Subscriber, formId: string, productId = ''): Promise<void> {
    this.open();
    this._subscriber = subscriber;
    this._productId = productId;
    await this.dynamicFormDelegate.buildForm(formId, { ...subscriber.common });
  }

  async updateSubscriberWithPLineFormAnswers(): Promise<void> {
    const updatedSubscriber = { ...this._subscriber };
    const formFields = this.dynamicFormDelegate.formAnswers;

    if (updatedSubscriber.common) {
      Object.keys(formFields).forEach((key) => {
        updatedSubscriber.common![key as keyof PersonInfo] = formFields[key] != null ? formFields[key] : '';
      });
    }

    await updateSubscriberInfo(this._periodId, updatedSubscriber as Subscriber);
    runInAction(() => {
      this.close();
      toastManager.addToast('Data saved successfully', ToastColorTypes.SUCCESS);
    });
  }

  constructor({ periodId }: DomainParams) {
    super();
    this._periodId = periodId;
    makeObservable<
      ProductLineRateModalDelegate,
      '_periodId' | '_rootStore' | '_subscriber' | 'openAndFetchForm' | 'updateSubscriberWithPLineFormAnswers'
    >(this, {
      _periodId: observable,
      _rootStore: observable,
      _subscriber: observable,
      dynamicFormDelegate: observable,
      openAndFetchForm: action.bound,
      updateSubscriberWithPLineFormAnswers: action.bound,
    });
  }
}
